import { API_VERSION_ESYMANDANT, fetchHandler, fileUploadWithBlobRequestBuilder, limiter } from 'application/api/request_builders'
import { handleApiResponse } from 'application/api/response_handlers'

export const postFilesWithBlobByAccountId = (accountId, blob, files) => {
    const request = fileUploadWithBlobRequestBuilder(API_VERSION_ESYMANDANT + '/e.consult.' + accountId + '/files/upload', blob, files)

    return limiter.schedule(() => fetchHandler(request.url, request.data))
        .then(handleApiResponse)
}